import React, { ReactElement } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useLocalization } from "@progress/kendo-react-intl";
import { enMessages } from "../../../messages/en-US";
import { EventFilter } from "../../Events/Utilities/EventsApiService";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningCircleIcon } from "@progress/kendo-svg-icons";

interface Props {
  selectedItem: string;
  eventFilter: EventFilter;
  parentItems: any;
  dataType: string;
  onLoadDetails: () => void;
  DetailsComponent: React.ComponentType<any>;
  detailsProps?: any;
}

export default function DataLoaderPage(props: Props): ReactElement {
  const localizationService = useLocalization();
  const [showDetails, setShowDetails] = React.useState<boolean>(false);

  // Reset to show placeholder every time selectedItem changes
  React.useEffect(() => {
    setShowDetails(false);
  }, [props.selectedItem]);

  const handleLoadDetails = () => {
    setShowDetails(true);
    props.onLoadDetails();
  };

  if (showDetails) {
    return (
      <props.DetailsComponent
        key={`${props.selectedItem}${props.dataType}DetailsPage`}
        {...props.detailsProps}
      />
    );
  }

    return (
    <div className="mt-10 flex flex-col items-center justify-center text-center">
         <div className="text-center mb-5">
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <SvgIcon icon={warningCircleIcon} size="xxxlarge" />
          </span>
        </div>
      <h3 className="gb-text-normal text-lg mb-4">
        {localizationService.toLanguageString('custom.fetchingDataForThisItemCouldTakeSomeTime', enMessages.custom.fetchingDataForThisItemCouldTakeSomeTime)}
      </h3>
      <p className="text-sm mb-6">
        {localizationService.toLanguageString('custom.clickTheButtonBelowToContinue', enMessages.custom.clickTheButtonBelowToContinue)}
      </p>
      <Button
        themeColor="primary"
        onClick={handleLoadDetails}
        className="px-6 py-2"
      >
        {localizationService.toLanguageString('custom.fetchData', enMessages.custom.fetchData)}
      </Button>
    </div>
  );
}
